import { render, staticRenderFns } from "./InvoiceCard.vue?vue&type=template&id=30c07d4f&"
import script from "./InvoiceCard.vue?vue&type=script&lang=js&"
export * from "./InvoiceCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports